import { CoverageLineModel } from "./coverageLine.model";
import { InvolvedCoverageModel } from "./involvedCoverage.Model";
import { PriceLinesModel } from "./price-lines.model";
import { WorkingOrderLineAttachment } from "./working-order-line-attachment";

export class PieceLayoutModel{
         wolId : string;
         wolWorkingOrderId :string;
         wolIsForProductSelection:boolean;
         wolIsClosed:boolean;
         wolIsManuallyAdded:boolean;
         wolDossierPriorityId:string;
         wolParentId:string;
         wolDueDate:Date;
         wolCreatedDate:Date
         wolLastModifiedDate:Date;
         wolPurchaseOrderId:string;
         wolTaskWorkActivityId:string;
         wolPurchaseOrderLineId:string;
         wolLineNumber:number;
         wolSupplierId:string;
         wolSubContractorId:string;
         wolExecutionSupplierId:string;
         wolComment:string;    
         wolInvoiceNumber:string;
         workingOrderLineCosts: PriceLinesModel[] = [];
         workingOrderLineAttachments :WorkingOrderLineAttachment[]=[];
         wolStatus :string;
         wolStatusId :string;
         wolCreatedBy  :string;
         wolLastModifiedBy  :string;
         wolCurrency :string;
         wolCoverageParty :any;
         wolCoverageProduct :any;
         wolServiceDate :any;
         wolHelpPlanList: any[] = [];
         wolItNumber :any;
         wolHasPurchaseInvoice : boolean =false;
         wolCurrencyCode: string;
         involvedCoverage: InvolvedCoverageModel;
         workingOrderLineCoverages: CoverageLineModel[] = [];
}